import { createContext } from "react";
import { ITrendReportContext } from "./TrendReportContextInterfaces";

export const initialState: ITrendReportContext = {
    selectedProductionLine: undefined,
    handleSelectedProductionLineChange: () => {},
    selectedPreviousProductionLine: undefined,
    handleSelectedPreviousProductionLineChange: () => {},
    showAllProductionLines: true,
    handleShowAllProductionLinesChange: () => {},

    millCountryCode: "",
    handleSetMillCountryCode: () => {},

    showAllFailureTypes: true,
    handleShowAllFailureTypesChange: () => {},
    selectedPreviousFailureType: undefined,
    handleSelectedPreviousFailureTypeChange: () => {},
    selectedFailureType: undefined,
    handleSetSelectedFailureType: () => {},

    showAllMachineCenters: true,
    handleShowAllMachineCentersChange: () => {},
    selectedPreviousMachineCenter: undefined,
    handleSelectedPreviousMachineCenterChange: () => {},
    selectedMachineCenter: undefined,
    handleSetSelectedMachineCenter: () => {},

    showAllFailureCodes: true,
    handleShowAllFailureCodesChange: () => {},
    selectedPreviousFailureCode: undefined,
    handleSelectedPreviousFailureCodeChange: () => {},
    selectedFailureCode: undefined,
    handleSetSelectedFailureCode: () => {},

    showAllSecondaryFailureCodes: true,
    handleShowAllSecondaryFailureCodesChange: () => {},
    selectedPreviousSecondaryFailureCode: undefined,
    handleSelectedPreviousSecondaryFailureCodeChange: () => {},
    selectedSecondaryFailureCode: undefined,
    handleSetSelectedSecondaryFailureCode: () => {},

    totalDowntimeSeconds: undefined,
    handleSetTotalDowntimeSeconds: () => {},
};

export const TrendReportContext = createContext(initialState);
